<template>
  <div class="header">
    <navbar />
    <div class="header-home">
      <div class="container">
        <div
          class="left"
          @click="() => handleHome()"
        >
          <img
            :src="settings.logo"
            :alt="settings.name"
            :title="settings.name"
          />
        </div>
        <div class="right">
          <a
            v-for="(item, i) in menu"
            :class="[
              'menu-item',
              0 == i ? 'menu-item-active' : ''
            ]"
            :key="i"
            @click="() => handleMenuClick(item)"
          >
            {{item.label}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import go from "@/utils/go";
import mixins from "@/mixins";
import Navbar from "@/components/navbar";
import { getSettings } from "@/api/setting";
import { headerNav } from "@/api/home";
export default {
  mixins: [mixins],
  components: {
    Navbar
  },
  data(){
    return {
      settings: {},
      menu: []
    };
  },
  watch: {
    "$route.path"(){
      this.main();
    }
  },
  methods: {
    async main(){
      const
        { params } = this.$route,
        settings = await getSettings(),
        menu = await headerNav(params);
      this.$set(this, "settings", settings);
      this.$set(this, "menu", menu);
    },
    handleHome(){
      go.to("home");
    }
  },
  mounted(){
    this.main();
  }
};
</script>

<style lang="less" scoped>
.header-home {
  padding: 35px 0;
  .container {
    display: flex;
    .left, .right {
      flex: 1;
    }
    .left {
      text-align: left;
      min-width: 350px;
      max-width: 350px;
      height: 63.36px;
      img {
        cursor: pointer;
        object-fit: contain;
        width: 100%;
        height: 100%;
        border: none;
      }
    }
    .right {
      text-align: right;
      .menu-item {
        cursor: pointer;
        margin-left: 33px;
        font-size: 16px;
        font-weight: 500;
        line-height: 63.6px;
        color: #666666;
        &-active {
          color: @primary-color;
        }
      }
    }
  }
}
</style>